import { restClient } from '../client';

export type NextAssessmentOutput = { status: 'not_found' }
| { status: 'found'; submission_id: string };

export const getNextAssessment = restClient.createRequest<null, NextAssessmentOutput>({
  url: '/api/v1/form/next_form',
  method: 'GET',
});
